import * as React from "react";
import type { SVGProps } from "react";
const SvgRss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 3c9.941 0 18 8.059 18 18M3 12a9 9 0 0 1 9 9m-9 0h.053"
    />
  </svg>
);
export default SvgRss;
